export function HorizontalSeparator(): JSX.Element {
  return (
    <div className="rounded-full h-[6px] w-[6px] bg-gray-400 inline-block"></div>
  );
}
